<div class="row col-12 p-0 m-0">
  <div class="col-11 p-0 company-details-section">
    <div class="col-height">
      <div class="">
        <div class="details-background">
          <div class="breadcrumbs-section">
            <span class="prev-page pb-1 "><a routerLink="/overview">Home</a></span>
            <img class="separator pl-2 pr-2" src="../../../assets/images/seperator.png">
            <span class="prev-page  "><a routerLink="/companies/companies-list">Companies</a></span>
            <img class="separator pl-2 pr-2" src="../../../assets/images/seperator.png">
            <span class="curr-page breadcrumbs-section-font">Company Details</span>
          </div>
          <label class="meetings padding-left-employees">Company Details</label>
          <div class="col-12 row d-flex padding-left-employees">
            <div class="col-10">

              <div class="row MTB-20">
                <div class="col-6 p-0">
                  <div class="col-12">
                    <span class="name">
                      Company Name
                    </span>
                  </div>
                  <div class="col-12">
                    <span class="details">
                      {{teamDetails?.companyName}}
                    </span>
                  </div>
                </div>
                <div class="col-6 p-0">
                  <div class="col-12">
                    <span class="name">
                      Company Domain(s)
                    </span>
                  </div>
                  <div class="col-12">
                    <span class="details">
                      {{teamDetails?.domain1}}{{teamDetails?.domain2 ? ', ' + teamDetails.domain2 :
                      ''}}{{teamDetails?.domain3 ? ', ' + teamDetails.domain3 : ''}}
                    </span>
                  </div>
                </div>
              </div>

              <div class="row MTB-20">
                <div class="col-6 p-0">
                  <div class="col-12">
                    <span class="name">
                      Activation Date
                    </span>
                  </div>
                  <div class="col-12">
                    <span class="details">
                      {{convertDateFormat(memberships?.startDate | date: 'dd-MM-yyyy')}}
                    </span>
                  </div>
                </div>
                <div class="col-6 p-0">
                  <div class="col-12">
                    <span class="name">
                      End Date
                    </span>
                  </div>
                  <div class="col-12">
                    <span class="details">
                      {{convertDateFormat(memberships?.endDate | date: 'dd-MM-yyyy')}}
                    </span>
                  </div>
                </div>
              </div>
              <div class="row MTB-20">
                <div class="col-6 p-0">
                  <div class="col-12">
                    <span class="name">
                      Membership Type
                    </span>
                  </div>
                  <div class="col-12">
                    <span class="details">
                      {{membershipType}}
                    </span>
                  </div>
                </div>
                <div class="col-6 p-0">
                  <div class="col-12">
                    <span class="name">
                      Credits/Month
                    </span>
                  </div>
                  <div class="col-12">
                    <span class="details">
                      {{availableCreditPoints}}
                    </span>
                  </div>
                </div>
              </div>
              <div class="row MTB-20">
                <div class="col-6 p-0">
                  <div class="col-12">
                    <span class="name">
                      Pax
                    </span>
                  </div>
                  <div class="col-12 ">
                    <span class="details">
                      {{teamDetails?.pax? teamDetails.pax:0}}
                    </span>
                  </div>
                </div>
                <div class="col-6 p-0">
                  <div class="col-12">
                    <span class="name">
                      Building Name
                    </span>
                  </div>
                  <div class="col-12">
                    <span class="details">
                      {{teamDetails?.address}}
                    </span>
                  </div>
                </div>
              </div>
              <div class="row MTB-20">
                <div class="col-6 p-0">
                  <div class="col-12">
                    <span class="name">
                      Parking (2 Wheeler)
                    </span>
                  </div>
                  <div class="col-12">
                    <span class="details">
                      {{teamDetails?.twowheelparking? teamDetails?.twowheelparking:0}}
                    </span>
                  </div>
                </div>
                <div class="col-6 p-0">
                  <div class="col-12">
                    <span class="name">
                      Parking (4 Wheeler)
                    </span>
                  </div>
                  <div class="col-12">
                    <span class="details">
                      {{teamDetails?.fourwheelparking? teamDetails?.fourwheelparking: 0}}
                    </span>
                  </div>
                </div>
              </div>

              <!-- <div class="row MTB-20">
                <div class="col-6 p-0">
                  <div class="col-12">
                    <span class="name">
                      Available Card(s)
                    </span>
                  </div>
                  <div class="col-12">
                    <span class="details">
                      {{allocatedCardCountDetails?.data?.totalAvailableCard? allocatedCardCountDetails?.data?.totalAvailableCard:0}}
                    </span>
                  </div>
                </div>
                <div class="col-6 p-0">
                  <div class="col-12">
                    <span class="name">
                      Tenant Allocated Card(s)
                    </span>
                  </div>
                  <div class="col-12">
                    <span class="details">
                      {{allocatedCardCountDetails?.data?.tenantAllocatedCard? allocatedCardCountDetails?.data?.tenantAllocatedCard:0}}
                    </span>
                  </div>
                </div>
              </div> -->

              <div class="row MTB-20">
                <div class="col-6 p-0">
                  <div class="col-12">
                    <span class="name">
                      Tenant Allocated Card(s)
                    </span>
                  </div>
                  <div class="col-12">
                    <span class="details">
                      {{allocatedCardCountDetails?.data?.tenantAllocatedCard?
                      allocatedCardCountDetails?.data?.tenantAllocatedCard:0}}
                    </span>
                  </div>
                </div>
                <div class="col-6 p-0">
                  <div class="col-12">
                    <span class="name">
                      Tenant Member Allocated Card(s)
                    </span>
                  </div>
                  <div class="col-12">
                    <span class="details">
                      {{allocatedCardCountDetails?.data?.tenantMemberAllocatedCard?
                      allocatedCardCountDetails?.data?.tenantMemberAllocatedCard:0}}
                    </span>
                  </div>
                </div>
              </div>

            </div>
            <div class="col-2 p-0">
              <!-- <div class="circle">
                <div class="circle-name">{{getName(companyName)}}</div>
              </div> -->
            </div>
          </div>
        </div>

        <div>
          <div class="d-flex justify-content-between padding-left-employees padding-right-employees mt-4">
            <div class="activation-width mt-3">
              <span class="pr-4 activation">Activation </span>
              <label class="switch pl-5">
                <!-- <input type="checkbox" [checked]="teamDetails?.isActive" value="teamDetails?.isActive"
                  [(ngModel)]="activation" (change)="toggleActivationSelection($event)"> -->
                <input type="checkbox" [checked]="activation" value="teamDetails?.isActive" [(ngModel)]="activation"
                  (ngModelChange)="toggleActivationSelection($event)" (change)="toggleActivationSelection($event)">
                <span class="slider round "></span>
              </label>
            </div>
            <div class="mt-3">
              <a href="javascript:void(0)" class="company-domain-link" (click)="openDomainModal(true)">Add/Update
                Company
                Domain(s)</a>
            </div>
          </div>

          <!-- Domain Modal -->
          <ng-template #domainModal let-modal>
            <div class="modal-header position-relative">
              <div class="modal-header-content">
                <h4 class="modal-title mb-2">Company Domains</h4>
                <p class="modal-subtitle mb-0">Please Add the Company Domain(s)</p>
              </div>
              <button type="button" class="close modal-close-btn" aria-label="Close" (click)="modal.dismiss()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form [formGroup]="domainForm">
                <div class="form-group">
                  <label>Domain 1 <span class="text-danger">*</span></label>
                  <input type="text" class="form-control" formControlName="domain1"
                    placeholder="Enter domain (e.g. @google.com)">
                  <div *ngIf="domainForm.get('domain1').touched && domainForm.get('domain1').invalid"
                    class="text-danger">
                    <small *ngIf="domainForm.get('domain1').errors?.required">Domain 1 is required</small>
                    <small *ngIf="domainForm.get('domain1').errors?.pattern">Invalid domain format</small>
                  </div>
                </div>
                <div class="form-group">
                  <label>Domain 2</label>
                  <input type="text" class="form-control" formControlName="domain2"
                    placeholder="Enter domain (e.g. @google.com)">
                  <div *ngIf="domainForm.get('domain2').touched && domainForm.get('domain2').invalid"
                    class="text-danger">
                    <small *ngIf="domainForm.get('domain2').errors?.pattern">Invalid domain format</small>
                  </div>
                </div>
                <div class="form-group">
                  <label>Domain 3</label>
                  <input type="text" class="form-control" formControlName="domain3"
                    placeholder="Enter domain (e.g. @google.com)">
                  <div *ngIf="domainForm.get('domain3').touched && domainForm.get('domain3').invalid"
                    class="text-danger">
                    <small *ngIf="domainForm.get('domain3').errors?.pattern">Invalid domain format</small>
                  </div>
                </div>
                <!-- Add duplicate domains error message -->
                <div *ngIf="domainForm.errors?.duplicateDomains" class="text-danger mb-3">
                  <small>All domains must be unique</small>
                </div>
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="cancel-button" (click)="modal.dismiss()">
                <span class="cancel">Cancel</span>
              </button>
              <button type="button" class="add-button"
                [disabled]="!domainForm.valid || domainForm.errors?.duplicateDomains" (click)="saveDomains()">
                <span class="add">Save</span>
              </button>
            </div>
          </ng-template>

          <ng-template #contentActivation let-modal class="text-center">
            <div class="modal-height">
              <div class="modal-body">
                <div class="">
                  <div class="text pt-3 pb-3">Are you sure, you want to {{statusText}}?</div>
                  <div class="popup-line"></div>
                </div>
              </div>
              <div class="submit col-12 d-flex justify-content-end ">
                <div class="pr-3">
                  <button type="button " class="cancel-button pt-3"
                    (click)="modal.close('Save click');onCancel('activation')"><span
                      class="cancel">Cancel</span></button>
                </div>
                <button type="button " class="add-button"><span class="add"
                    (click)="updateTenantStatus();modal.close('Save click')">{{statusText}}</span></button>
              </div>
            </div>
          </ng-template>
          <!-- <div class="activation-width pl-4 mt-3 ">
              <span class="pr-4 activation">Privilege </span>
              <label class="switch pl-5">
                <input type="checkbox" [checked]="teamDetails?.isPriviledge" value="tableSelected"
                  [(ngModel)]="priviledge" (ngModelChange)="togglePriviledgeSelection($event)"
                  (change)="togglePriviledgeSelection($event)">
                <span class="slider round "></span>
                <ng-template #contentPriviledge let-modal class="text-center">
                  <div class="modal-height">
                    <div class="modal-body">
                      <div class="">
                        <div class="text pt-3 pb-3">Are you sure, you want to revoke privilege</div>
                        <div class="popup-line"></div>
                      </div>
                    </div>
                    <div class="submit col-12 d-flex justify-content-end ">
                      <div class="pr-3">
                        <button type="button " class="cancel-button pt-3"
                          (click)="modal.close('Save click');onCancel('priviledge')"><span
                            class="cancel">Cancel</span></button>
                      </div>
                      <button type="button " class="add-button"><span class="add"
                          (click)="revokeAccess()">Revoke</span></button>
                    </div>
                  </div>
                </ng-template>
              </label>
            </div> -->
        </div>

        <div class="padding-left-employees padding-right-employees">
          <div class="line "></div>
        </div>

        <div *ngIf="!add && !edit">
          <div class="padding-left-employees access pt-3">
            Admin
          </div>
          <form [formGroup]="addForm">
            <div class="row">
              <div class="col-10">
                <div class="d-flex justify-textbox padding-left-employees mt-4">
                  <div class="row" style="width: 100%;">
                    <div class="col-6">
                      <input type="text" [ngClass]="name?'textbox-onselect':'textbox-style'"
                        [class.error-input]="fieldErrors.includes('name')" name="fname"
                        class="search-line  pl-4 placeholder-text" formControlName="fname" [(ngModel)]="fullname"
                        [placeholder]="!name ? 'Full Name' : ''" (click)="enterName('name')" (blur)="enterName('name')"
                        pattern="^[a-zA-Z ]{2,50}$" (keyup)="inputModelChange('name')">
                      <label *ngIf="name" class="form-lable-email" for="mobile-emailid">Full Name</label>
                      <div
                        *ngIf="(addForm.controls.fname.invalid && addForm.controls.fname.dirty) || fieldErrors.includes('name')"
                        class="field-error">
                        Please enter valid
                        name</div>

                    </div>
                    <div class="col-6">
                      <input type="email" [ngClass]="email?'textbox-onselect':'textbox-style'"
                        [class.error-input]="fieldErrors.includes('email')" class="search-line  pl-4 placeholder-text"
                        formControlName="email" name="email" [(ngModel)]="emailId"
                        pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$" (keyup)="inputModelChange('email')"
                        [placeholder]="!email ? 'Email ID' : ''" (click)="enterName('email')"
                        (blur)="enterName('email')">
                      <label *ngIf="email" class="form-lable-email" for="mobile-emailid">Email ID</label>
                      <div
                        *ngIf="(addForm.controls.email.invalid && addForm.controls.email.dirty) || fieldErrors.includes('email')"
                        class="field-error">
                        Please enter valid
                        email</div>
                    </div>
                  </div>
                </div>

                <div class="d-flex justify-textbox padding-left-employees mt-4">
                  <div class="row" style="width: 100%;">
                    <div class="col-6">
                      <input type="text" [ngClass]="mobile?'textbox-onselect-mobile':'textbox-style'"
                        class="search-line  pl-4 placeholder-text" formControlName="phnumber" name="phnumber"
                        (keyup)="inputModelChange('phone')" [class.error-input]=" fieldErrors.includes('phone')"
                        [(ngModel)]="phoneNumber" [placeholder]="!mobile ? 'Mobile Number' : ''" maxlength="10"
                        (click)="enterName('mobile')" (blur)="enterName('mobile')" pattern="^\d{10}$">
                      <label *ngIf="mobile" class="form-lable-mobile" for="mobile-emailid">Mobile Number</label>
                      <div
                        *ngIf="(addForm.controls.phnumber.invalid && addForm.controls.phnumber.dirty) || fieldErrors.includes('phone')"
                        class="field-error">Please enter
                        valid
                        mobile number</div>
                    </div>
                    <div class="col-6">
                      <div class="textbox-style pointer-link" style="position: relative;">
                        <div (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'" [ngbPopover]="popContent"
                          triggers="manual" #p="ngbPopover" (click)="openPopover(p);enterName('department')"
                          placement="bottom" popoverClass='dash-popover dashboard-popover'>
                          <input class="pt-3 pb-3 pl-4 input-width placeholder-text pointer-link"
                            [placeholder]="!dept ? 'Department' : ''"
                            [class.error-input]=" fieldErrors.includes('dept')" [(ngModel)]="departmentName"
                            formControlName="deptName" name="deptName" readonly required>
                          <label *ngIf="dept" class="form-lable-dept" for="mobile-emailid">Department</label>

                          <img src="/assets/images/down-arrow.png" class="image-pos padding-left-image pr-1"
                            loading="lazy" />
                        </div>
                        <div
                          *ngIf="(addForm.controls.deptName.invalid && addForm.controls.deptName.dirty) || fieldErrors.includes('dept')"
                          class="field-error" [ngStyle]="{'margin-top':!dept?'-22px':null}">Please
                          select
                          valid
                          department</div>
                        <div>
                          <ng-template #popContent>
                            <div class="dashboard-popover">
                              <div class="d-flex justify-content-between">
                                <div class="pl-3 pt-3 pr-3 pb-3 ">
                                  <div class="row pb-2" *ngFor="let department of deptList;let index =i"
                                    (click)="setDepartment(department); openPopover(p);inputModelChange('dept')">
                                    <div class="popover-content normal-font pl-3 email-width">
                                      {{department.department}}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                        </div>
                        <!-- </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-2 margin-auto">
                <div class="">
                  <img class="circle-image-pos" src="assets/images/add-admin.png">
                </div>
              </div>
            </div>


            <div class="padding-left-employees pt-4">
              <span>
                <button (click)="addClick()" type="button " class="add-button btn"><span
                    class="add">Save</span></button>
              </span>
            </div>
            <div class="padding-left-employees padding-right-employees " *ngIf="add">
              <div class="line "></div>
            </div>

            <!--
                        <div class="padding-left-employees padding-right-employees">
                            <div class="line "></div>
                        </div> -->

          </form>
          <div class="padding-left-employees padding-right-employees" *ngIf="!add">
            <!-- <div class="line "></div> -->
          </div>
        </div>

        <div *ngIf="edit">
          <div class="padding-left-employees access pt-3">
            Admin
          </div>
          <div [formGroup]="editForm">
            <div class="row">
              <div class="col-10">
                <div class="d-flex justify-textbox padding-left-employees mt-4">
                  <div class="row" style="width: 100%;">
                    <div class="col-6">
                      <input type="text" [ngClass]="name?'textbox-onselect':'textbox-style'" name="fname"
                        class="search-line  pl-4 placeholder-text" formControlName="fname" [(ngModel)]="fullname"
                        (keyup)="inputModelChange('name')" [placeholder]="!name ? 'Full Name' : ''"
                        (click)="enterName('name')">
                      <label *ngIf="name" class="form-lable-email" for="mobile-emailid">Full Name</label>
                      <div
                        *ngIf="(addForm.controls.fname.invalid && addForm.controls.fname.dirty) || fieldErrors.includes('name')"
                        class="field-error">
                        Please enter valid
                        name</div>
                    </div>
                    <div class="col-6">
                      <input type="email" [ngClass]="email?'textbox-onselect':'textbox-style'"
                        class="search-line  pl-4 placeholder-text" formControlName="email" name="email"
                        [(ngModel)]="emailId" [placeholder]="!email ? 'Email ID' : ''" (click)="enterName('email')"
                        (keyup)="inputModelChange('email')">
                      <label *ngIf="email" class="form-lable-email" for="mobile-emailid">Email ID</label>
                      <div
                        *ngIf="(addForm.controls.email.invalid && addForm.controls.email.dirty) || fieldErrors.includes('email')"
                        class="field-error">
                        Please enter valid
                        email</div>
                    </div>
                  </div>
                </div>

                <div class="d-flex justify-textbox padding-left-employees mt-4">
                  <div class="row" style="width: 100%;">
                    <div class="col-6">
                      <input type="text" [ngClass]="mobile?'textbox-onselect-mobile':'textbox-style'"
                        class="search-line  pl-4 placeholder-text" formControlName="phnumber" name="phnumber"
                        [(ngModel)]="phoneNumber" [placeholder]="!mobile ? 'Mobile Number' : ''" maxlength="10"
                        minlength="10" (keyup)="inputModelChange('phone')" (click)="enterName('mobile')">
                      <label *ngIf="mobile" class="form-lable-mobile" for="mobile-emailid">Mobile Number</label>
                      <div
                        *ngIf="(addForm.controls.phnumber.invalid && addForm.controls.phnumber.dirty) || fieldErrors.includes('phone')"
                        class="field-error">Please enter
                        valid
                        mobile number</div>
                    </div>
                    <div class="col-6">
                      <div class="textbox-style pointer-link" style="position: relative;">
                        <div (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'" [ngbPopover]="popContent"
                          triggers="manual" #p="ngbPopover" (click)="openPopover(p)" placement="bottom"
                          popoverClass='dash-popover dashboard-popover'>
                          <input class="placeholder-text pl-4"
                            class="pt-3 pb-3 pl-4 input-width placeholder-text pointer-link"
                            [placeholder]="!dept ? 'Department' : ''" (click)="enterName('department')"
                            [(ngModel)]="departmentName" formControlName="deptName" name="deptName" readonly>
                          <label *ngIf="dept" class="form-lable-dept" for="mobile-emailid">Department</label>
                          <div
                            *ngIf="(addForm.controls.deptName.invalid && addForm.controls.deptName.dirty) || fieldErrors.includes('dept')"
                            class="field-error">Please
                            select
                            valid
                            department</div>
                          <img src="/assets/images/down-arrow.png" class="image-pos padding-left-image pr-1" />
                        </div>
                        <div>
                          <ng-template #popContent>
                            <div class="dashboard-popover box ">
                              <div class="d-flex justify-content-between">
                                <div class="pl-3 pt-3 pr-3 pb-3 ">
                                  <div class="row pb-2" *ngFor="let department of deptList;let index =i"
                                    (click)="setDepartment(department); openPopover(p); inputModelChange('dept')">
                                    <div class="popover-content normal-font pl-3 email-width">
                                      {{department.department}}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-2 margin-auto">
                <!-- <div class="">
                    <img class="circle-image-pos" src="assets/images/add-admin.png">
                  </div> -->
                <div class="circle" style="margin-top: 20px;">
                  <div class="circle-name">{{getName(fullname)}}</div>
                </div>
              </div>
            </div>

            <div class="padding-left-employees pt-4">
              <span (click)="editAddClick()">
                <button type="button " class="add-button"><span
                    class="add">Save</span></button>
              </span>
              <button type="button " class="cancel-button pl-3" (click)="removeAdmin()"><span class="cancel">Remove
                  Admin</span></button>
            </div>
            <div class="padding-left-employees padding-right-employees " *ngIf="add">
              <div class="line "></div>
            </div>


            <!-- <div class="padding-left-employees padding-right-employees">
                <div class="line "></div>
              </div> -->

          </div>
        </div>
        <div *ngIf="add && !edit" class="padding-left-employees padding-right-employees">
          <div class="row ">
            <div class="col-12" style="width: 100%;">
              <div class="row">
                <div class="col-9">
                  <div class="access pt-4 pb-3">
                    Admin
                  </div>
                </div>
                <div class="col-3 editDetails">
                  <span class="edit-details" (click)="editdetails()">
                    Edit details
                  </span>
                </div>
              </div>
            </div>
            <div class="col-9">
              <div class="row MTB-20">
                <div class="col-6 p-0">
                  <div class="col-12">
                    <span class="name">
                      Name
                    </span>
                  </div>
                  <div class="col-12">
                    <span class="details">
                      {{fullname}}
                    </span>
                  </div>
                </div>
                <div class="col-6 p-0">
                  <div class="col-12">
                    <span class="name">
                      Email ID
                    </span>
                  </div>
                  <div class="col-12">
                    <span class="details">
                      {{emailId|lowercase}}</span>
                  </div>
                </div>
              </div>
              <div class="row MTB-20">
                <div class="col-6 p-0">
                  <div class="col-12">
                    <span class="name">
                      Mobile Number
                    </span>
                  </div>
                  <div class="col-12">
                    <span class="details">
                      +91-{{phoneNumber}}
                    </span>
                  </div>
                </div>
                <div class="col-6 p-0">
                  <div class="col-12">
                    <span class="name">
                      Department
                    </span>
                  </div>
                  <div class="col-12">
                    <span class="details">
                      {{departmentName}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-3">
              <!-- <div class="col-12">
                  <span class="edit-details" (click)="editdetails()">
                    Edit details
                  </span>
                </div> -->
              <div class="col-12">
                <div class="circle" style="margin-left: 15%;margin-top: 20px;">
                  <div class="circle-name">{{getName(fullname)}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="padding-left-employees padding-right-employees row">
          <div class="line "></div>
        </div>
      </div>

      <div>
        <div class="d-flex justify-content-between mt-5">
          <div class="padding-left-employees access">
            Access
          </div>
          <div class="justify-content-end padding-right-employees">
            <span class="pr-5 select-all">Select all</span>
            <label class="switch pl-5">
              <input type="checkbox" [checked]="selectAll" [(ngModel)]="selectAll" value="selectAll"
                (change)="toggleSelectAllSelection($event)" [disabled]=!activation>
              <span class="slider round "></span>
            </label>
          </div>
        </div>
        <div *ngIf="entryGate.length>0">
          <span class="padding-left-employees entry-gate">Entry Gate</span>
          <div class="padding-left-employees row d-flex mt-3">
            <ng-container class="" *ngFor="let eg of entryGate;let i=index">
              <div class="pr-4 d-flex">
                <div (click)="changeAccess(eg,'entryGate')" [ngClass]="(eg.selected)?'rectangle-select ':'rectangle '">
                  <span [ngClass]="(eg.selected)?'text-font':'text-font-deselected'">{{eg.label}}</span>
                </div>
                <span>
                  <img *ngIf="eg.selected" class="image-pos-cross justify-content-end"
                    src="/assets/images/cross-mark.png" (click)="changeAccess(eg,'entryGate')"></span>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="mt-4" *ngIf="meetingRoomAccess.length>0">
          <span class="padding-left-employees entry-gate ">Meeting Room Access
          </span>
          <div class="padding-left-employees row d-flex mt-3">
            <ng-container class="" *ngFor="let mr of meetingRoomAccess;let i=index">
              <div class="pr-4 d-flex pt-2">
                <div (click)="changeAccess(mr,'meetingRoomAccess')"
                  [ngClass]="(mr.selected)?'rectangle-select ':'rectangle '">
                  <span [ngClass]="(mr.selected)?'text-font':'text-font-deselected'">{{mr.label}}</span>
                </div>
                <span>
                  <img *ngIf="mr.selected" class="image-pos-cross justify-content-end"
                    src="/assets/images/cross-mark.png" (click)="changeAccess(mr,'meetingRoomAccess')"></span>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="mt-4" *ngIf="deskAccess.length>0" style="display: none;">
          <span class="padding-left-employees entry-gate ">Desk Access
          </span>
          <div class="padding-left-employees row d-flex mt-3">
            <ng-container class="" *ngFor="let da of deskAccess;let i=index">
              <div class="pr-4 d-flex pt-2">
                <div (click)="changeAccess(da,'deskAccess')" [ngClass]="(da.selected)?'rectangle-select ':'rectangle '">
                  <span [ngClass]="(da.selected)?'text-font':'text-font-deselected'">{{da.label}}</span>
                </div>
                <span>
                  <img *ngIf="da.selected" class="image-pos-cross justify-content-end"
                    src="/assets/images/cross-mark.png" (click)="changeAccess(da,'deskAccess')"></span>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="mt-4" *ngIf="privateSuiteAccess.length>0">
          <span class="padding-left-employees entry-gate ">Private Suite Access
          </span>
          <div class="padding-left-employees row d-flex mt-3">
            <ng-container class="" *ngFor="let ps of privateSuiteAccess;let i=index">
              <div class="pr-4 d-flex pt-2">
                <div (click)="changeAccess(ps,'privateSuiteAccess')"
                  [ngClass]="(ps.selected)?'rectangle-select ':'rectangle '">
                  <span [ngClass]="(ps.selected)?'text-font':'text-font-deselected'">{{ps.label}}</span>
                </div>
                <span>
                  <img *ngIf="ps.selected" class="image-pos-cross justify-content-end"
                    src="/assets/images/cross-mark.png" (click)="changeAccess(ps,'privateSuiteAccess')"></span>
              </div>
            </ng-container>
          </div>
        </div>
        <div *ngIf="premiumSuiteAccess.length>0" class="mt-2">
          <span class="padding-left-employees entry-gate">Premium Suite</span>
          <div class="padding-left-employees row d-flex mt-3">
            <ng-container class="" *ngFor="let eg of premiumSuiteAccess;let i=index">
              <div class="pr-4 d-flex">
                <div (click)="changeAccess(eg,'premiumSuiteAccess')"
                  [ngClass]="(eg.selected)?'rectangle-select ':'rectangle '">
                  <span [ngClass]="(eg.selected)?'text-font':'text-font-deselected'">{{eg.label}}</span>
                </div>
                <span>
                  <img *ngIf="eg.selected" class="image-pos-cross justify-content-end"
                    src="/assets/images/cross-mark.png" (click)="changeAccess(eg,'premiumSuiteAccess')"></span>
              </div>
            </ng-container>
          </div>
        </div>
        <div *ngIf="premiumPlusSuiteAccess.length>0" class="mt-2">
          <span class="padding-left-employees entry-gate">Premium Plus Suite</span>
          <div class="padding-left-employees row d-flex mt-3">
            <ng-container class="" *ngFor="let eg of premiumPlusSuiteAccess;let i=index">
              <div class="pr-4 d-flex">
                <div (click)="changeAccess(eg,'premiumPlusSuiteAccess')"
                  [ngClass]="(eg.selected)?'rectangle-select ':'rectangle '">
                  <span [ngClass]="(eg.selected)?'text-font':'text-font-deselected'">{{eg.label}}</span>
                </div>
                <span>
                  <img *ngIf="eg.selected" class="image-pos-cross justify-content-end"
                    src="/assets/images/cross-mark.png" (click)="changeAccess(eg,'premiumPlusSuiteAccess')"></span>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <!-- <div *ngIf="!isRfidEnabled">
          <div class="padding-left-employees padding-right-employees">
            <div class="line "></div>
          </div>

          <div class="padding-left-employees access pt-3">
            Disburse RFID cards (Count)
          </div>

          <form [formGroup]="rfidForm">
            <div class="row">
              <div class="col-10">
                <div class="d-flex justify-textbox padding-left-employees mt-4">
                  <div class="row" style="width: 100%;">
                    <div class="col-6">
                      <input type="text" pattern="[0-9]*" [ngClass]="assignrfid?'textbox-onselect':'textbox-style'"
                        name="rfidcount" class="search-line  pl-4 placeholder-text" formControlName="rfidcount"
                        [(ngModel)]="assingedRfidNumber" (keyup)="inputModelChange('assignrfid')"
                        [placeholder]="!assignrfid ? 'Assign RFID' : ''" (click)="enterNameRfid('assignrfid')">
                      <label *ngIf="assignrfid" class="form-lable-email" for="mobile-emailid">Assign RFID</label>
                      <div
                        *ngIf="(rfidForm.controls.rfidcount.invalid && rfidForm.controls.rfidcount.dirty) || fieldErrors.includes('assignrfid')"
                        class="field-error">
                        Please enter the number of card(s) to be disbured</div>
                    </div>
                    <div class="col-6">
                      <div class="padding-left-employees pt-1">
                        <button type="button" class="btn btn-primary" [disabled]="rfidForm.invalid"
                          (click)="saveRfidValue()">Assign</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="padding-left-employees pt-2">
            <p>Available RFID Card(s) - {{teamDetails?.availableCardCout?teamDetails.availableCardCout:0}}</p>
            <p>Allocated RFID Card(s) - {{teamDetails?.allocatedCardCount?teamDetails.allocatedCardCount:0}}</p>
          </div>
        </div> -->

      <!-- <div class="padding-left-employees padding-right-employees row">
          <div class="line "></div>
        </div>

        <div style="margin-top: 25px;" *ngIf="!isRfidEnabled">
          <div class="bulk-layout">

            <label class="access pt-4">Bulk Upload</label>

            <div class="row">
              <div class="col-5 right-border">

                <div class="row">
                  <div class="col-12">
                    <p class="step mt-3">Step 1</p>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <h2>Enter Data</h2>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <div class="text">We have created a format to help you input member card id data that
                      will
                      make it easier to
                      upload
                      information.
                      Please download the below excel sheet to fill in your member card id data.</div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <div class="flex-column d-flex mt-3">
                      <label>
                        <a [attr.href]="baseUrl" download><img src="../../assets/images/excel.png"><span
                            class="download pl-2">Download Excel Sheet here</span>
                        </a>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-1 vertical-line"></div>

              <div class="col-5 ml-0 pl-0">
                <div class="row">
                  <div class="col-12">
                    <p class="step mt-3">Step 2</p>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <h2>And Upload Here</h2>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <div class="text">Once you have filled in your member card id data in the downloaded
                      excel
                      sheet, upload the
                      document here.</div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <input id="uploadfile-input" type="file"
                      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      (change)="handleFileSelect($event)" style="display: none;" />
                    <label for="uploadfile-input">
                      <span class="button"><img class="mr-1" src="../../assets/images/add-excel.png">
                        Upload
                        Excel
                        Sheet here</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-1"></div>
            </div>

            <div *ngIf="success">
              <hr class="ml-0 mt-3">
              <div class="row mt-4">
                <div class="col-1"><img class="success-icon" src="../../assets/images/green-tick.png"></div>
                <div class="col-11 ml-0 pl-0">
                  <p class="sucess">Upload successful</p>
                </div>
              </div>
            </div>
          </div>
        </div> -->


      <!-- <div class="col-12 p-0 bulk-upload-preview" *ngIf="tableHeaders.length > 0">
          <div class="col-height">
            <div class="invite-layout">
              <div class="row mt-4">
                <div class="col-12 guest-count">{{tableBody.length}} Member Card ID(s)</div>
              </div>
              <div class="row">
                <div class="col-12 scroll" style="height: 400px; overflow-y: scroll;">
                  <table class="table table-borderless table-striped table-curved mt-4" id="pdfTable" #pdfTable
                    *ngIf="tableHeaders.length > 0">
                    <thead>
                      <tr>
                        <th class="check-container">
                          <label class="check-container mb-0">
                            <input type="checkbox" [checked]="selectAllMemberCard" [value]="selectAllMemberCard"
                              [(ngModel)]="selectAllMemberCard" (change)="selectAllHandler()">
                            <span class="checkmark"></span>
                          </label>
                        </th>
                        <th *ngFor="let th of tableHeaders | slice:0:2;" scope="col">{{th}}</th>
                        <th></th>
                        <th>
                          <i class="fa fa-2x fa-trash" aria-hidden="true" (click)="deleteAllInvites()"
                            [ngClass]="{'disabledClick':!selectAllMemberCard}"></i>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let td of tableBody; let i = index" [id]="generateUniqueId(i,'tr')"
                        [ngClass]="{'error-row': validationError[i]?.length > 0 ||  isValid[i] == false }">
                        <td class="check-container">
                          <label class="check-container">
                            <input type="checkbox" [checked]="selectAllMemberCard" [value]="selectAllMemberCard"
                              (change)="selectedGuest(td, i, $event)" [id]="generateUniqueId(i,'th')" />
                            <span class="checkmark"></span>
                          </label>
                        </td>
                        <td *ngFor="let cell of td | slice:0:2 |  keyvalue;let j = index ">
                          <span [ngClass]="generateUniqueId(i,'td')" style="display: block;">{{cell.value}}</span>
                          <input type="{{j==0 ? 'text' : 'text' }}" [ngClass]="generateUniqueId(i,'input')"
                            style="display: none;" [value]="cell.value" class="edit-input" />
                          <span *ngIf="j != 0 && validationError[i] != null  "
                            class="error-row-display">{{validationError[i][j-1] }}</span>
                        </td>
                        <td><i class="fa fa-2x fa-pencil" aria-hidden="true" [ngClass]="checkIfSelected(i+'__th')"
                            (click)="editSelected(i+'__td', i+'__input', i, 'edit')" [id]="generateUniqueId(i,'edit')"
                            style="display: block; cursor: pointer;"></i>
                          <span [id]="generateUniqueId(i,'save')" style="display: none; cursor: pointer;"
                            (click)="editSelected(i+'__td', i+'__input', i, 'save')" class="save-btn">Save</span>
                          <span [id]="generateUniqueId(i,'save')" style="display: none; cursor: pointer;"
                            (click)="editSelected(i+'__td', i+'__input', i, 'cancel')" class="save-btn">Cancel</span>
                        </td>
                        <td>
                          <i class="fa fa-2x fa-trash" aria-hidden="true" [ngClass]="checkIfSelected(i+'__th')"
                            (click)="deleteSelected(td,i)" style="cursor: pointer;"></i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="col-2"></div>
              </div>
            </div>
            <div class="row footer-layout " *ngIf="tableHeaders.length > 0">
              <div class="col-2 align-right">
                <button class="button-cancel" (click)="cancelTable()">Cancel</button>
              </div>
              <div class="col-2">
                <button class="button-resend" [disabled]="validationEr" (click)="send()">Bulk Upload</button>
              </div>
            </div>
          </div>
        </div> -->



      <div class="padding-left-employees padding-right-employees">
        <div class="line "></div>
      </div>

      <div>
        <label class="padding-left-employees booking-history pt-4">Access Log</label>
        <div class="d-flex row col-12 pt-3 padding-left-employees">
          <div class="form-group capitaland-form-group mr-4">
            <label for="owner-dob" class="form-label  from">From</label>
            <input class="form-control form-control-lg cal-icon cal-style cal-text" (click)="d.toggle()"
              autocomplete="off" [readonly]="true" (keypress)="$event.preventDefault()" id="owner-dob"
              placeholder="dd | mm | yyyy" type="text" name="dp" ngbDatepicker #d="ngbDatepicker"
              [(ngModel)]="accessFromDate">
            <span class="field-error" *ngIf="accessFromDateErr">Please enter valid From date</span>
            <!-- <img src="assets/images/calendar.svg" class="iLife-form-group_custom " (click)="d.toggle()" /> -->
          </div>
          <div class="form-group capitaland-form-group" style="position:relative">
            <label for="owner-dob" class="form-label from">To</label>
            <input class="form-control form-control-lg cal-icon cal-style cal-text" (click)="d1.toggle()"
              autocomplete="off" [readonly]="true" (keypress)="$event.preventDefault()" id="owner-dob"
              placeholder="dd | mm | yyyy" type="text" name="dp" ngbDatepicker #d1="ngbDatepicker"
              [(ngModel)]="accessToDate">
            <span class="field-error" *ngIf="accessToDateErr">Please enter valid To date</span>
            <!-- <img src="assets/images/calendar.svg" class="iLife-form-group_custom" (click)="d1.toggle()" /> -->
          </div>
          <div class="pl-4 pt-3">
            <button class="view" (click)="navigateToReportsWithFilter($event,1)">
              View
            </button>
          </div>
        </div>
      </div>
      <div>
        <label class="padding-left-employees booking-history pt-4">Credit Usage</label>
        <div class="d-flex row col-12 pt-3 padding-left-employees">
          <div class="form-group capitaland-form-group mr-4">
            <label for="owner-dob" class="form-label  from">From</label>
            <input class="form-control form-control-lg cal-icon cal-style cal-text" (click)="d2.toggle()"
              autocomplete="off" [readonly]="true" (keypress)="$event.preventDefault()" id="owner-dob"
              placeholder="dd | mm | yyyy" type="text" name="dp" ngbDatepicker #d2="ngbDatepicker"
              [(ngModel)]="creditFromDate">
            <span class="field-error" *ngIf="creditFromDateErr">Please enter valid From date</span>
            <!-- <img src="assets/images/calendar.svg" class="iLife-form-group_custom " (click)="d.toggle()" /> -->
          </div>
          <div class="form-group capitaland-form-group" style="position:relative">
            <label for="owner-dob" class="form-label from">To</label>
            <input class="form-control form-control-lg cal-icon cal-style cal-text" (click)="d3.toggle()"
              autocomplete="off" [readonly]="true" (keypress)="$event.preventDefault()" id="owner-dob"
              placeholder="dd | mm | yyyy" type="text" name="dp" ngbDatepicker #d3="ngbDatepicker"
              [(ngModel)]="creditToDate">
            <span class="field-error" *ngIf="creditToDateErr">Please enter valid To date</span>
            <!-- <img src="assets/images/calendar.svg" class="iLife-form-group_custom" (click)="d1.toggle()" /> -->
          </div>
          <div class="pl-4 pt-3">
            <button class="view" (click)="navigateToReportsWithFilter($event,0)">
              View
            </button>
          </div>
        </div>
      </div>
      <div class=" mb-5">
        <label class="padding-left-employees booking-history pt-4">Meeting Room Usage</label>
        <div class="d-flex row col-12 pt-3 padding-left-employees">
          <div class="form-group capitaland-form-group mr-4">
            <label for="owner-dob" class="form-label  from">From</label>
            <input class="form-control form-control-lg cal-icon cal-style cal-text" (click)="d4.toggle()"
              autocomplete="off" [readonly]="true" (keypress)="$event.preventDefault()" id="owner-dob"
              placeholder="dd | mm | yyyy" type="text" name="dp" ngbDatepicker #d4="ngbDatepicker"
              [(ngModel)]="meetingFromDate">
            <span class="field-error" *ngIf="meetingFromDateErr">Please enter valid From date</span>
            <!-- <img src="assets/images/calendar.svg" class="iLife-form-group_custom " (click)="d.toggle()" /> -->
          </div>
          <div class="form-group capitaland-form-group" style="position:relative">
            <label for="owner-dob" class="form-label from">To</label>
            <input class="form-control form-control-lg cal-icon cal-style cal-text" (click)="d5.toggle()"
              autocomplete="off" [readonly]="true" (keypress)="$event.preventDefault()" id="owner-dob"
              placeholder="dd | mm | yyyy" type="text" name="dp" ngbDatepicker #d5="ngbDatepicker"
              [(ngModel)]="meetingToDate">
            <span class="field-error" *ngIf="meetingToDateErr">Please enter valid To date</span>
            <!-- <img src="assets/images/calendar.svg" class="iLife-form-group_custom" (click)="d1.toggle()" /> -->
          </div>
          <div class="pl-4 pt-3">
            <button class="view" (click)="navigateToReportsWithFilter($event, 3)">
              View
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>

  <!-- <div class="padding-left-employees">
                <div class="line "></div>
            </div> -->

</div>